declare const __AUTH_URL__: string | undefined;
declare const __ROLES_URL__: string | undefined;
declare const __WAREHOUSE_API_URL__: string | undefined;
declare const __NEXBOT_URL__: string | undefined;
declare const __WAREHOUSE_URL__: string | undefined;
declare const __TRACKING_URL__: string | undefined;

export const CONFIG = {
  AUTH_URL: typeof __AUTH_URL__ !== "undefined" ? __AUTH_URL__ : "http://localhost:3200",
  ROLES_URL: typeof __ROLES_URL__ !== "undefined" ? __ROLES_URL__ : "http://localhost:3300",
  WAREHOUSE_API_URL: typeof __WAREHOUSE_API_URL__ !== "undefined" ? __WAREHOUSE_API_URL__ : "http://localhost:3800/v1",
  NEXBOT_URL: typeof __NEXBOT_URL__ !== "undefined" ? __NEXBOT_URL__ : "http://localhost:8080/admin",
  WAREHOUSE_URL: typeof __WAREHOUSE_URL__ !== "undefined" ? __WAREHOUSE_URL__ : "http://localhost:8081",
  TRACKING_URL: typeof __TRACKING_URL__ !== "undefined" ? __TRACKING_URL__ : "http://localhost:3000/es/dashboard",
} as const;
